import React from 'react';

const VoiceComponent = () => {
  const voiceBundles = {
    '1_day': {
      title: '1 DAY VOICE BUNDLE',
      packages: [
        { minutes: '30 min', price: 'R5' },
        { minutes: '60 min', price: 'R9' }
      ]
    },
    '7_day': {
      title: '7 DAY VOICE BUNDLE',
      packages: [
        { minutes: '50 min', price: 'R9' },
        { minutes: '100 min', price: 'R15' }
      ]
    },
    '30_day': {
      title: '30 DAY VOICE BUNDLE',
      packages: [
        { minutes: '50 min', price: 'R15' },
        { minutes: '100 min', price: 'R25' },
        { minutes: '500 min', price: 'R89' },
        { minutes: '1,000 min', price: 'R149' }
      ]
    },
    '180_day': {
      title: '180 DAY VOICE BUNDLE',
      packages: [
        { minutes: '1,000 min', price: 'R199' },
        { minutes: '2,000 min', price: 'R349' },
        { minutes: '5,000 min', price: 'R799' },
        { minutes: '10,000 min', price: 'R1499' }
      ]
    }
  };

  const styles = {
    container: {
      background: '#378082',
      borderRadius: '16px',
      padding: '32px',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
      fontFamily: 'Poppins, sans-serif',
    },
    header: {
      color: 'white',
      fontSize: '28px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '32px',
      letterSpacing: '1px'
    },
    columnsContainer: {
      display: 'flex',
      gap: '32px',
      flexWrap: 'wrap'
    },
    column: {
      flex: 1,
      minWidth: '300px'
    },
    rightColumn: {
      flex: 1,
      borderLeft: '1px solid rgba(255, 255, 255, 0.2)',
      paddingLeft: '32px'
    },
    bundleSection: {
      marginBottom: '32px'
    },
    bundleTitle: {
      backgroundColor: '#59C0A1',
      color: 'white',
      fontSize: '14px',
      fontWeight: '600',
      padding: '12px 16px',
      borderRadius: '50px',
      textAlign: 'center',
      marginBottom: '24px'
    },
    packageItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: '12px',
      marginBottom: '16px',
      borderBottom: '1px solid rgba(255, 255, 255, 0.2)'
    },
    minutes: {
      color: 'white',
      fontSize: '16px'
    },
    price: {
      color: 'white',
      fontSize: '16px',
      fontWeight: '500'
    },
    '@media (max-width: 768px)': {
      columnsContainer: {
        flexDirection: 'column'
      },
      rightColumn: {
        borderLeft: 'none',
        paddingLeft: '0',
        borderTop: '1px solid rgba(255, 255, 255, 0.2)',
        paddingTop: '32px'
      }
    }
  };

  const BundleSection = ({ bundle }) => (
    <div style={styles.bundleSection}>
      <div style={styles.bundleTitle}>
        {bundle.title}
      </div>
      <div>
        {bundle.packages.map((pkg, index) => (
          <div key={index} style={styles.packageItem}>
            <span style={styles.minutes}>{pkg.minutes}</span>
            <span style={styles.price}>{pkg.price}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>
        STANDARD RATES
      </h2>
 <p style={{paddingBottom: "20px", textAlign: "center"}}>      <strong>k'nect bundles are available at all tills in-store, via USSD *135# or on Money Market Account.</strong>
      </p>
      <div style={styles.columnsContainer}>
        {/* Left Column */}
        <div style={styles.column}>
          <BundleSection bundle={voiceBundles['1_day']} />
          <BundleSection bundle={voiceBundles['7_day']} />
        </div>

        {/* Right Column */}
        <div style={styles.rightColumn}>
          <BundleSection bundle={voiceBundles['30_day']} />
          <BundleSection bundle={voiceBundles['180_day']} />
        </div>
      </div>
    </div>
  );
};

export default VoiceComponent;